// extracted by mini-css-extract-plugin
export var headingStyling = "HeadingComponent-module--headingStyling--786d1";
export var heroHeading = "HeadingComponent-module--heroHeading--c2898";